import React, { useEffect, useState } from "react";
import Card from "react-bootstrap/Card";

function TotalRAndDSpend({ rAndDSpendEstimates }) {
  const [featured, setFeatured] = useState([]);
  const [priorities, setPriorities] = useState([]);
  const [totalSpend, setTotalSpend] = useState("");
  const [cagr, setCagr] = useState("");

  useEffect(() => {
    if (rAndDSpendEstimates?.[0]?.response?.fields) {
      const { fields } = rAndDSpendEstimates?.[0]?.response;

      // Total Spend & CAGR
      if (fields.total_spend_metrics) {
        setTotalSpend(fields.total_spend_metrics.total_amount || "");
        setCagr(fields.total_spend_metrics.cagr || "");
      }

      // Featured (historical_focus_areas)
      if (fields.historical_focus_areas) {
        const historicalArr = Object.values(fields.historical_focus_areas);
        setFeatured(historicalArr);
      }

      // Current & Emerging Priorities
      if (fields.current_emerging_priorities) {
        const priorityArr = Object.values(fields.current_emerging_priorities);
        setPriorities(priorityArr);
      }
    }
  }, [rAndDSpendEstimates]);

  return (
    <div className="total_rd_wrapper mb-4">
      <h5 className="total_rd_head">
        R&D Focus
        {/* Featured R&D Spend (
        {rAndDSpendEstimates?.[0]?.fields?.total_spend_metrics?.time_period ||
          "N/A"}
        ): {totalSpend} | CAGR: {cagr} */}
      </h5>
      <div className="total_rd_block">
        <div className="row">
          {/* Featured */}
          <div className="col-md-6">
            <div className="total_rd_card_block">
              <Card className="total_rd_card">
                <Card.Header className="total_rd_card_header">
                  Featured
                </Card.Header>
                <Card.Body className="total_rd_card_body">
                  {featured.map((item, idx) => (
                    <div className="top_area_block" key={idx}>
                      <h5 className="top_area_head">
                        {item.title}
                        {/* – {item.investment} */}
                      </h5>
                      <p className="top_area_para">{item.description}</p>
                    </div>
                  ))}
                </Card.Body>
              </Card>
            </div>
          </div>

          {/* Current & Emerging Priorities */}
          <div className="col-md-6">
            <div className="total_rd_card_block">
              <Card className="total_rd_card">
                <Card.Header className="total_rd_card_header">
                  Current & Emerging Priorities
                </Card.Header>
                <Card.Body className="total_rd_card_body">
                  {priorities.map((item, idx) => (
                    <div className="top_area_block" key={idx}>
                      <h5 className="top_area_head">
                        {item.title}
                        {/* – {item.investment} */}
                      </h5>
                      <p className="top_area_para">{item.description}</p>
                    </div>
                  ))}
                </Card.Body>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TotalRAndDSpend;
